import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=7d6c4a16&scoped=true&"
import script from "./Categorias.vue?vue&type=script&lang=js&"
export * from "./Categorias.vue?vue&type=script&lang=js&"
import style0 from "./Categorias.vue?vue&type=style&index=0&id=7d6c4a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c4a16",
  null
  
)

export default component.exports